/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_UnnamedInputs */

const en_seller_notice_unnamed = /** @type {(inputs: Seller_Notice_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this business`)
};

const pl_seller_notice_unnamed = /** @type {(inputs: Seller_Notice_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ta firma`)
};

/**
* | output |
* | --- |
* | "this business" |
*
* @param {Seller_Notice_UnnamedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_unnamed = /** @type {((inputs?: Seller_Notice_UnnamedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_UnnamedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_unnamed(inputs)
	return en_seller_notice_unnamed(inputs)
});